module.exports = __webpack_public_path__ + "static/media/world-barn-dance.cb759c0b.mp4";